import { render, staticRenderFns } from "./d-card0.vue?vue&type=template&id=5f5067f1&scoped=true"
import script from "./d-card0.vue?vue&type=script&lang=js"
export * from "./d-card0.vue?vue&type=script&lang=js"
import style0 from "./d-card0.vue?vue&type=style&index=0&id=5f5067f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5067f1",
  null
  
)

export default component.exports